/** Thrown by an upload that was cancelled through its abort signal. */
export class SplatUploadCancelledError extends Error {
  public override readonly name = 'SplatUploadCancelledError';

  /** False when the splat created for the upload could not be deleted. */
  constructor(public readonly cleanedUp: boolean) {
    super('Gaussian splat upload was cancelled');
  }
}
